import React from "react";
import { shade } from "polished";
import styled, { ThemeProvider } from "styled-components";
import { Box, Flex } from "rebass";
import GradientHeader from "./GradientHeader";
import H1 from "./Headings/H1";
import invertTheme from "../invertTheme";

const Wrapper = styled(GradientHeader)`
  animation: fade-in 400ms ease forwards;
  animation-delay: 200ms;
  opacity: 0;
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &::selection {
    color: ${(props) =>
      props.theme.colors[props.color] &&
      shade(0.5, props.theme.colors[props.color])};
    background-color: ${(props) => props.theme.colors.grey[0]};
  }
  a {
    color: white !important;
    box-shadow: inset 0 -1px 0 white !important;
    &:hover {
        color: ${(props) => props.theme.colors.violet} !important;
        box-shadow: inset 0 -1.5em 0 white !important;
      }
  }
}
`;

const Heading = styled(H1)`
  color: ${(props) => props.theme.colors.grey[0]};

  &::selection {
    color: ${(props) =>
      props.theme.colors[props.color] &&
      shade(0.75, props.theme.colors[props.color])};
    background-color: ${(props) => props.theme.colors.grey[0]};
  }
`;

Heading.defaultProps = {
  my: [3, 5],
  fontSize: [5, 6],
};

// const Layout = styled(Flex)`
//   align-items: flex-start;
//   &::selection {
//     color: ${props =>
//       props.theme.colors[props.color] &&
//       shade(0.75, props.theme.colors[props.color])};
//     background-color: ${props => props.theme.colors.grey[0]};
//   }

//   > * {
//     width: calc(50% - 8px);
//     margin-left: 48px;
//     margin-bottom: ${props => props.theme.space[5]}px;

//     &:first-child {
//       margin-left: 0;
//     }
//   }

//   @media only screen and (max-width: 40em) {
//     align-items: center;
//     flex-wrap: wrap;
//     width: 100%;

//     > * {
//       width: 100%;
//       margin-bottom: 16px;
//       margin-left: 0;
//     }
//   }

//   * {
//     &::selection {
//       color: ${props =>
//         props.theme.colors[props.color] &&
//         shade(0.75, props.theme.colors[props.color])};
//       background-color: ${props => props.theme.colors.grey[0]};
//     }
//   }
// `;

const Container = styled(Box)`
  width: 100%;
  max-width: 624px;

  * {
    &::selection {
      color: ${(props) =>
        props.theme.colors[props.color] &&
        shade(0.75, props.theme.colors[props.color])};
      background-color: ${(props) => props.theme.colors.grey[0]};
    }
  }
`;

const determineColor = function (page) {
  let color = "violet";
  if (
    page === "updates" ||
    page === "institutions" ||
    page === "about" ||
    page === "pages" ||
    page === "campaigns" ||
    page === "resources" ||
    page === "support" ||
    page === "careers" ||
    page === "reports" ||
    page === "team" ||
    page === "contact" ||
    page === "member" ||
    page === null ||
    page === undefined
  ) {
    color = "violet";
  }
  if (
    page === "middle-east-and-north-africa" ||
    page === "oriente-medio-y-norte-de-africa" ||
    page === "الشرق-الاوسط-وشمات-افريقيا"
  ) {
    color = "orange";
  }
  if (page === "africa" || page === "africa1" || page === "افريقيا") {
    color = "green";
  }
  if (
    page === "latin-america" ||
    page === "america-latina-y-el-caribe" ||
    page === "امريكا-اللاتينية"
  ) {
    color = "blue";
  }
  if (page === "asia" || page === "asia1" || page === "اسيا") {
    color = "pink";
  }
  if (
    page === "europe--central-asia" ||
    page === "europa-y-asia-central" ||
    page === "اوروبا-واسيا-الوسطى"
  ) {
    color = "yellow";
  }
  return color;
};

const PageHeader = (props) => (
  <ThemeProvider theme={invertTheme}>
    <Wrapper
      image={props.image}
      className={props.className}
      style={props.style}
      color={determineColor(props.color)}
    >
      <Container color={determineColor(props.color)}>
        <Heading children={props.title} color={determineColor(props.color)} />
        {/* {props.children && (
        <Layout color={determineColor(props.color)}>{props.children}</Layout>
      )} */}
        <Box mb={[3, 5]}>{props.children}</Box>
      </Container>
    </Wrapper>
  </ThemeProvider>
);

PageHeader.defaultProps = {
  image: "https://source.unsplash.com/random",
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js